export default __webpack_public_path__ + "static/media/img_video_off.d4c33767.svg";